import { render } from "./SidebarSublinkContainer.vue?vue&type=template&id=1c4b96b4"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__